import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  margin-top: 1.5rem;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
`;
